
import API from '../api'; // your axios instance or API helper

export const addActivity = async (employee_id, message, type = 'other') => {
  try {
    console.log(employee_id, message, type);
    const token = localStorage.getItem('token');
    await API.post('/admin/activities', { employee_id, message, type }, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error('Failed to add activity:', error);
  }
};
